import { Box, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { CashFunds } from '@withjoy/joykit/icons';
import { CashFundComponentConfig } from './CashFundComponent.config';
import type { AdminSidebarComponentProps } from '@apps/websiteCustomJsonComponents/customComponents/JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useGoToCreateView } from '@apps/websiteCustomJsonComponents/customComponents/hooks/useJsonComponentNavigation';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { CashFundComponentData } from '@shared/websiteCustomJsonComponents/CashFundComponent/CashFundComponent.types';
import { DEFAULT_CURRENCY } from '@shared/utils/currency/constants';
import { useTranslation } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { ComponentType } from '@graphql/generated';
import { InfoTooltip } from '@shared/components/InfoTooltip';

export const CashFundComponentGrabber = (props: AdminSidebarComponentProps) => {
  const content = props.componentData.containerContent.content as CashFundComponentData | undefined;
  const { tq } = useTranslation('websitePages');
  return (
    <SimpleGrabHandle
      title={tq`Cash Fund`}
      subTitle={content?.name}
      icon={<CashFunds />}
      {...props}
    />
  );
};

export const CashFundComponentAdd = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('websitePages');
  const { goToCreateView } = useGoToCreateView();
  const eventInfo = useEventInfo();
  const eventId = eventInfo?.eventInfo?.eventId;

  const handleClick = useEventCallback(() => {
    // Initial placeholder content - real data is populated when user saves after selecting/creating a fund
    const content: CashFundComponentData = {
      cashFundId: '',
      name: '',
      currencyCode: DEFAULT_CURRENCY,
      hideGoal: false,
    };
    goToCreateView({
      id: props.componentData.id,
      containerContent: {
        id: props.containerId,
        type: CashFundComponentConfig.componentType,
        content,
        eventId: eventId || '',
        schemaUrl: CashFundComponentConfig.schemaUrl,
      },
      type: ComponentType.jsonDataBlob,
      sortOrder: props.componentData?.sortOrder,
      jsonDataContainerId: props.containerId,
      __typename: 'JsonDataBlobComponent',
    });
  }, [props.componentData.id, props.containerId, props.componentData?.sortOrder, eventId, goToCreateView]);

  return (
    <InfoTooltip
      title={tq`Cash Fund`}
      description={tq`Add your cash fund to any page so guests can contribute directly.`}
    >
      <Box>
        <LayoutAddComponentListItem onClick={handleClick}>
          <CashFunds size={48} />
          <TextV2
            typographyVariant="hed2"
            textAlign="left"
          >
            {tq`Cash Fund`}
          </TextV2>
        </LayoutAddComponentListItem>
      </Box>
    </InfoTooltip>
  );
};
